import { default as axios, AxiosResponse } from 'axios';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { IBarometerHypermediaRepresentation } from '../shared/contracts/BarometerContract';
import { urlService } from '../shared/services/UrlService';
import { IBarometerState, IRootState } from './contract';

const state: IBarometerState = {
    currentBarometer: undefined
};

const mutations: MutationTree<IBarometerState> = {
    barometerLoaded(barometerState: IBarometerState, payload: IBarometerHypermediaRepresentation) {
        barometerState.currentBarometer = payload;
    }
};

const actions: ActionTree<IBarometerState, IRootState> = {
    async fetchBarometer({ commit, rootState }, personId: number): Promise<void> {
        let url = urlService.replaceURIPlaceholders(rootState.root._links.barometer.href, { personId });
        let response: AxiosResponse<IBarometerHypermediaRepresentation> = await axios.get(url);
        commit('barometerLoaded', response && response.data);
        return;
    }
};

const getters: GetterTree<IBarometerState, IRootState> = {};

const namespaced: boolean = true;

export const barometer: Module<IBarometerState, IRootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
